import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiTwitter, FiInstagram, FiFacebook } = FiIcons;

const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleScrollToSection = (e, id) => {
    e.preventDefault();
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <footer className="bg-neutral-surface border-t border-neutral-border pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center gap-2.5 mb-4">
              <img 
                src="https://media-manager-c.questera.ai/greta-media/64b6f00450a2ccd8585f32418c01e01155b9a46657aed859be5d908803e7074989df043f4ede815d2dc0fa021038408b/images/aW1hZ2UvcG5n/9cfb9a87f42be2968b832fdb29a8d339.png" 
                alt="Logo" 
                className="w-9 h-9 rounded-xl object-cover shadow-soft flex-shrink-0"
              />
              <span className="text-base font-bold text-text-primary leading-tight">
                Pickleball<br />
                <span className="text-primary">Insight Coach</span>
              </span>
            </div>
            <p className="text-text-secondary max-w-xs mb-6">
              Record. Analyze. Improve. The simplest way to get better at pickleball.
            </p>
            <div className="flex gap-4">
              <a href="#" className="text-text-muted hover:text-primary transition-colors">
                <SafeIcon icon={FiTwitter} className="text-xl" />
              </a>
              <a href="#" className="text-text-muted hover:text-primary transition-colors">
                <SafeIcon icon={FiInstagram} className="text-xl" />
              </a>
              <a href="#" className="text-text-muted hover:text-primary transition-colors">
                <SafeIcon icon={FiFacebook} className="text-xl" />
              </a>
            </div>
          </div>

          {/* App Links */}
          <div>
            <h4 className="font-bold text-text-primary mb-4">App</h4>
            <ul className="space-y-3">
              <li><button onClick={(e) => handleScrollToSection(e, 'features')} className="text-text-secondary hover:text-primary transition-colors text-left">Features</button></li>
              <li><button onClick={(e) => handleScrollToSection(e, 'how-it-works')} className="text-text-secondary hover:text-primary transition-colors text-left">How it Works</button></li>
              <li><button onClick={(e) => handleScrollToSection(e, 'download')} className="text-text-secondary hover:text-primary transition-colors text-left">Pricing</button></li>
              <li><button onClick={(e) => handleScrollToSection(e, 'download')} className="text-text-secondary hover:text-primary transition-colors text-left">FAQ</button></li>
            </ul>
          </div>

          {/* Legal Links */}
          <div>
            <h4 className="font-bold text-text-primary mb-4">Legal</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/privacy" className="text-text-secondary hover:text-primary transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-text-secondary hover:text-primary transition-colors">
                  Terms of Service
                </Link>
              </li>
              <li>
                <a href="mailto:hello@pickleballinsightcoach.com" className="text-text-secondary hover:text-primary transition-colors">
                  Contact Us
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-neutral-divider text-center md:text-left md:flex justify-between items-center">
          <p className="text-text-muted text-sm">
            © {new Date().getFullYear()} Pickleball Insight Coach. All rights reserved.
          </p>
          <div className="mt-4 md:mt-0 flex justify-center gap-4 text-sm text-text-muted flex-wrap">
            <a href="#download-ios" className="hover:text-primary">Download on iOS</a>
            <span>•</span>
            <a href="#download-android" className="hover:text-primary">Download on Android</a>
            <span>•</span>
            <Link to="/privacy" className="hover:text-primary">Privacy</Link>
            <span>•</span>
            <Link to="/terms" className="hover:text-primary">Terms</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;